/*
 *  Copyright (c) 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

// Enums need to have the same name as ones in GQL because of TS bug https://github.com/microsoft/TypeScript/issues/35138

export enum CloudProviderType {
  Cloud = "CLOUD",
  Kubernetes = "KUBERNETES",
  Openshift = "OPENSHIFT",
  Vmware = "VMWARE",
}

export enum CloudWasteCategoryKey {
  Idle = "IDLE",
  Orphaned = "ORPHANED",
  OverProvisioned = "OVER_PROVISIONED",
  Turbonomic = "TURBONOMIC",
}

export enum CloudWasteSettingKey {
  IdleDatabase = "IDLE_DATABASE",
  IdleVmGcp = "IDLE_VM_GCP",
  KubeNodeOverProvisionedCpu = "KUBE_NODE_OVER_PROVISIONED_CPU",
  KubeNodeOverProvisionedMemory = "KUBE_NODE_OVER_PROVISIONED_MEMORY",
  KubePodOverProvisionedCpu = "KUBE_POD_OVER_PROVISIONED_CPU",
  KubePodOverProvisionedMemory = "KUBE_POD_OVER_PROVISIONED_MEMORY",
  OscpNodeOverProvisionedCpu = "OSCP_NODE_OVER_PROVISIONED_CPU",
  OscpNodeOverProvisionedMemory = "OSCP_NODE_OVER_PROVISIONED_MEMORY",
  OscpPodOverProvisionedCpu = "OSCP_POD_OVER_PROVISIONED_CPU",
  OscpPodOverProvisionedMemory = "OSCP_POD_OVER_PROVISIONED_MEMORY",
  OutdatedSnapshot = "OUTDATED_SNAPSHOT",
  OverProvisionedDb = "OVER_PROVISIONED_DB",
  OverProvisionedVm = "OVER_PROVISIONED_VM",
  StoppedVm = "STOPPED_VM",
  TurbonomicAction = "TURBONOMIC_ACTION",
  UnassignedIp = "UNASSIGNED_IP",
  UnassignedSecurityGroup = "UNASSIGNED_SECURITY_GROUP",
  UnattachedVolume = "UNATTACHED_VOLUME",
}

export enum CostMappingAlgorithm {
  Equal = "EQUAL",
  Manual = "MANUAL",
  Proportional = "PROPORTIONAL",
}

export enum EnvironmentType {
  Development = "DEVELOPMENT",
  Other = "OTHER",
  Production = "PRODUCTION",
  Staging = "STAGING",
}

export enum Provider {
  Aws = "AWS",
  Azure = "AZURE",
  External = "EXTERNAL",
  Gcp = "GCP",
  Hybrid = "HYBRID",
  Ibmcloud = "IBMCLOUD",
  Kubernetes = "KUBERNETES",
  Nordcloud = "NORDCLOUD",
  Openshift = "OPENSHIFT",
  Services = "SERVICES",
  Vmware = "VMWARE",
}

export enum Role {
  Admin = "ADMIN",
  ReadOnly = "READ_ONLY",
  TeamLead = "TEAM_LEAD",
  MspDashboard = "MSP_DASHBOARD",
}

export enum WorkflowExternalIntegrationType {
  Email = "EMAIL",
  ServiceNow = "SERVICE_NOW",
  Slack = "SLACK",
}

export enum WorkflowFrequency {
  Daily = "DAILY",
  Monthly = "MONTHLY",
  Weekly = "WEEKLY",
  Yearly = "YEARLY",
}

export enum WorkflowLastRunStatus {
  Completed = "COMPLETED",
  Failed = "FAILED",
  None = "NONE",
}

export enum WorkflowTriggerType {
  Manual = "MANUAL",
  Scan = "SCAN",
  Scheduler = "SCHEDULER",
}

export enum KubernetesType {
  Node = "NODE",
  Pod = "POD",
}

export enum IntegrationPluginSyncStatus {
  Completed = "COMPLETED",
  Failure = "FAILURE",
}

export enum IntegrationPluginType {
  Turbonomic = "TURBONOMIC",
}

export enum WorkflowDataType {
  SavingSuggestions = "SAVING_SUGGESTIONS",
  UnallocatedResources = "UNALLOCATED_RESOURCES",
}

export enum WorkflowEventStatus {
  Completed = "COMPLETED",
  Failed = "FAILED",
}
